<template>
    <div class = "personal-inf">
        <div class="personal-inf__item">
            <div class="personal-inf__title">Имя и Фамилия</div>
            <div class="inf-field">
                <div class="inf-field-title">
                    <div class="inf-field__name">Имя</div>
                </div>
                <reg-input :value="infoUser !== null ? infoUser.Detail.Name : ''" :pattern = "inputs[0].patternInput" @input = 'setDataName($event)'></reg-input>
            </div>
            <div class="inf-field">
                <div class="inf-field-title">
                    <div class="inf-field__name">Фамилия</div>
                </div>
                <reg-input :value="infoUser !== null ? infoUser.Detail.Surname : ''" :pattern = "inputs[1].patternInput" @input = 'setDataSurname($event)'></reg-input>
            </div>
            <div class="save-button" @click ='onChange'>Сохранить</div>
            <div class="avatar-container">
                <div class="personal-inf__title">Аватар</div>
                <img :src="urlAvatar">
                <div class="avatar-uploadWrap">
                    <div class="avatar-buttons">
                        <div class="avatar-buttonsItem">
                            <label for="avatar-upload" class="avatar-file-upload">Выбрать файл</label>
                            <input type="file" id="avatar-upload" ref="file" @change="avatarFileUpload()"/>
                            <div v-if="validFile" class="save-button" @click="saveAvatar()">Сохранить</div>
                        </div>
                        <div v-if="!defaultAvatar" class="delete-button" @click="removeAvatar()">Удалить</div>
                    </div>
                </div>
                <div v-if="errorMessage" class="inf-field__name color-red">Файл изображения должен иметь формат JPEG или PNG и не должен привышать размера более 3 мб</div>
             </div>
        </div>
        <div class="personal-inf__item">
            <div class="personal-inf__title">Контактная информация</div>
            <div class="inf-field" v-for = "(item,index) in contactInfo" :key="index">
                <div class="inf-field-title">
                    <i :class="item.ico"></i>
                <div class="inf-field__name">{{item.title}}</div></div>
                <reg-input :value="infoUser !== null ? infoUser.Detail[item.detail] : ''" :pattern = "item.patternInput" @input = 'setDataContact(index,$event)'></reg-input>
            </div>
            <div class="save-button" @click='onChange'>
                <loader v-if="loading" :styles="loaderStyle"/>
                <span v-if="!loading">Сохранить</span>
            </div>
            <div v-if="messageSave === 'error'" class="errorMessage">Ошибка сохранения данных!<br>Попробуйте повторить запрос позже!</div>
            <div v-if="messageSave === 'success'" class="successMessage">Данные успешно сохранены!</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Input from "../ui-components/reg-input"
import Loader from "../ui-components/preloader"
export default {
    components : {
        'reg-input':Input,
        'loader':Loader
    },
    data() {
        return {
            inputs: [{
                title:'Имя',
                patternInput: /^[а-яА-Я]{2,30}$/,
                value:''
            },
            {
                title:'Фамилия',
                patternInput: /^[а-яА-Я]{2,30}$/,
                value:''
            }],
            contactInfo: [{
                title:'Телефон',
                patternInput: /^[а-яА-Я]{2,30}$/,
                detail: 'Phone',
                ico:'icon-phone',
                value:''},
                {
                    title:'Сайт',
                    patternInput: /^[а-яА-Я]{2,30}$/,
                    detail:'Alias',
                    ico: 'icon-google-earth',
                    value:''
                },
                {
                    title:'TELEGRAM',
                    patternInput: /^[а-яА-Я]{2,30}$/,
                    detail:'Telegram',
                    ico:'icon-telegramm',
                    value:''
                },
                {
                    title:'VIBER',
                    patternInput: /^[а-яА-Я]{2,30}$/,
                    detail:'Viber',
                    ico:'icon-viber',
                    value:''
                },
                {
                    title:'WHATSAPP',
                    patternInput: /^[а-яА-Я]{2,30}$/,
                    detail:'WhatsUp',
                    ico:'icon-whatsapp',
                    value:''
                },
                {
                    title:'SKYPE',
                    patternInput: /^[а-яА-Я]{2,30}$/,
                    detail:'Skype',
                    ico:'icon-skype',
                    value:''
                },
            ],
            avatarFile:'',
            validFile:false,
            errorMessage:false,
            loaderStyle: {width:30 + 'px',height:30 + 'px', margin:0 + 'px'},
            loading:false,
            messageSave:null
        }
    },
    computed : {
        ...mapGetters({
            infoUser:'auth/getInfoUser',
            urlAvatar:'chat/getAvatarUrl',
            defaultAvatar:'chat/getSatusAvatar',
            getMessageSaveDetails:'auth/getMessageSaveUserDetail'
        })
    },
    methods : {
        setDataName(data) {
            this.inputs[0].value = data.value
        },
        setDataSurname(data) {
            this.inputs[1].value = data.value
        },
        setDataContact(index,data) {
            this.contactInfo[index].value = data.value
        },
        async onChange() {
            this.loading = true;
            this.messageSave = null;
            let payload = {
                    Login:this.infoUser.User.Login,
                    ChatPassword:this.infoUser.User.Password,
                    Name:this.inputs[0].value === null ? this.infoUser.Detail.Name : this.inputs[0].value,
                    Surname:this.inputs[1].value === null ? this.infoUser.Detail.Surname : this.inputs[1].value,
                    Phone:this.contactInfo[0].value === null ? this.infoUser.Detail.Phone : this.contactInfo[0].value,
                    Alias:this.contactInfo[1].value === null ? this.infoUser.Detail.Alias : this.contactInfo[1].value,
                    Telegram:this.contactInfo[2].value === null ? this.infoUser.Detail.Telegram : this.contactInfo[2].value,
                    Viber:this.contactInfo[3].value === null ? this.infoUser.Detail.Viber : this.contactInfo[3].value,
                    WhatsUp:this.contactInfo[4].value === null ? this.infoUser.Detail.WhatsUp : this.contactInfo[4].value,
                    Skype:this.contactInfo[5].value === null ? this.infoUser.Detail.Skype : this.contactInfo[5].value
                }
            await this.$store.dispatch('auth/saveUserDetail', payload);
            this.loading = false;
            this.messageSave = this.getMessageSaveDetails;
        },
        avatarFileUpload() {
            this.avatarFile = this.$refs.file.files[0];
        },
        saveAvatar() {
            this.$store.dispatch('chat/uploadAvatar', this.avatarFile);
            this.validFile = false;
        },
        removeAvatar() {
            this.$store.dispatch('chat/resetAvatar');
            this.validFile = false;
        }
    },
    watch: {
       avatarFile: function(value) {
            if(value.length !==0 && value.size < 3000000 && value.type === 'image/jpeg' || value.type === 'image/png') {
                this.validFile = true;
                this.errorMessage = false;
            } else {
                this.errorMessage = true;
                this.validFile = false;
            }
       }
    },
    mounted(){
        //this.infoUser = this.$store.getters['auth/getInfoUser']
        if(this.infoUser !== null) {
            this.inputs[0].value = this.infoUser.Detail.Name;
            this.inputs[1].value = this.infoUser.Detail.Surname;
            this.contactInfo[0].value = this.infoUser.Detail.Phone;
            this.contactInfo[1].value = this.infoUser.Detail.Alias;
            this.contactInfo[2].value = this.infoUser.Detail.Telegram;
            this.contactInfo[3].value = this.infoUser.Detail.Viber;
            this.contactInfo[4].value = this.infoUser.Detail.WhatsUp;
            this.contactInfo[5].value = this.infoUser.Detail.Skype;
        }
    }

}
</script>
<style lang="less">
.avatar {
    &-buttons {
        display: flex;
        align-items: baseline;
    }
    &-container {
        margin-top: 23px;
        display: flex;
        flex-direction: column;
        img {
            width:128px;
            height: 128px;
            margin-bottom: 23px;
            margin-top: 12px;
            border-radius: 128px;
        }
    }
    &-uploadWrap {
        margin-bottom: 8px;
    }
    &-file-upload {
        background-color: #324258;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.64;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #adc7e1;
        cursor: pointer;
        border-radius: 4px;
        padding: 14px 12px 14px 12px;
        height: 40px;
        box-sizing: border-box;
        margin-top: 16px;
        box-sizing: border-box;
        text-align: center;
        margin-right: 23px;
        &:hover {
            background-color: #0fd7b7;
            color: #293546;
        }
    }
}
.personal-inf {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    width: 100%;
    &__item {
        width: 444px;
        display: flex;
        flex-direction: column;
    }
}
.personal-inf__title {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 3;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
}
.inf-field {
    width: 100%;
    margin-bottom: 12px;
    &__name {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64 !important;
        letter-spacing: 0.4px;
        color: #adc7e1;
        text-transform: uppercase;
    }
    &-title {
        display:flex;
        align-items: center;
        height: 40px;

        i {
            font-size: 23px;
            margin-right: 8px;
            color:#718da8;
        }
    }
}
input[type="text"] {
    width: inherit;
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
    border-radius: 4px;
    background-color: rgba(113, 141, 168, 0);
    border: solid 1px #3d536b;
    padding-left: 12px;
    box-sizing: border-box;
}
input[type="file"] {
    display:none;
}
.save-button {
    background-color: #324258;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    height: 40px;
    line-height: 3.64;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #adc7e1;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    box-sizing: border-box;
    text-align: center;
}
.errorMessage {
    margin-top: 20px;
    font-family: Arimo;
    font-size: 16px;
    line-height: 1.5;
    color:@colors[red];
}
.successMessage {
    margin-top: 20px;
    font-family: Arimo;
    font-size: 16px;
    line-height: 1.5;
    color:@colors[green];
}
.delete-button {
    background-color: #d87272;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #374b62;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    width: 120px;
    box-sizing: border-box;
    text-align: center;
    &:hover {
        background-color: @colors[red];
    }
}

.save-button:hover {
    background-color: #0fd7b7;
    color: #293546;
}
</style>
